import moment from 'moment';
import { useRef, useState } from 'react';
import { BUTTON_SIZES, SecondaryButton } from 'ui/button';
import { ChevronDown16 } from 'ui/icons';
import { DateRangePicker } from 'ui/datePicker';
import { RELATIVE_DATE_PRESETS_WITH_ALL_TIME } from 'ui/datePicker/helpers';
import { useClickOutside } from 'utils/hooks/useClickOutside';
import { useInsightsBoundaryContext } from '../../../contexts/insightsBoundary';
import { useGetDisplayDate } from '../../../hooks';
import { ExpandedDateRangePickerWrapper, TimeframePickerWrapper } from './BehaviorInsights.styled';

export const testIds = {
  timeframePicker: 'insights-timeframe-picker-trigger',
  dateRangePicker: '"data-range-picker"',
};

export const InsightsTimeframePicker = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const { startDate, endDate, setStartDate, setEndDate } = useInsightsBoundaryContext();
  const [isExpanded, setIsExpanded] = useState(false);
  useClickOutside(wrapperRef, () => {
    setIsExpanded(false);
  });
  const displayDateRange = useGetDisplayDate(startDate, endDate);

  return (
    <TimeframePickerWrapper ref={wrapperRef}>
      <SecondaryButton
        onClick={() => setIsExpanded((prevIsExpanded) => !prevIsExpanded)}
        data-test={testIds.timeframePicker}
        size={BUTTON_SIZES.LARGE}
      >
        {displayDateRange}
        <ChevronDown16 />
      </SecondaryButton>
      {isExpanded && (
        <ExpandedDateRangePickerWrapper data-test={testIds.dateRangePicker}>
          <DateRangePicker
            startDate={startDate ? moment(startDate) : null}
            endDate={endDate ? moment(endDate) : null}
            onDateRangeChange={(newRange) => {
              setStartDate(newRange.startDate?.toDate() || null);
              setEndDate(newRange.endDate?.toDate() || null);
            }}
            presets={RELATIVE_DATE_PRESETS_WITH_ALL_TIME}
            showRelativeDatePresets
            blockFutureDates
            hasAllTimePreset
          />
        </ExpandedDateRangePickerWrapper>
      )}
    </TimeframePickerWrapper>
  );
};
